export default (theme) => ({
  root: {
    padding: theme.spacing(3),
    backgroundColor: '#00AFEF',
    cursor: 'pointer',
  },
  content: {
    alignItems: 'center',
    display: 'flex',
  },
  value: {
    marginTop: theme.spacing(1),
    color: '#fff',
  },
  title: {
    fontWeight: 700,
    backgroundColor: '#730065',
    fontSize: '16px',
    color: 'white',
  },
  iconWrapper: {
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: '50%',
    display: 'inline-flex',
    height: '4rem',
    justifyContent: 'center',
    marginLeft: 'auto',
    width: '4rem',
    transform: 'rotate(-90deg)',
  },
  icon: {
    color: '#00AFEF',
    fontSize: '2rem',
    height: '2rem',
    width: '2rem',
  },
  footer: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
  },
  difference: {
    alignItems: 'center',
    color: theme.palette.success.dark,
    display: 'inline-flex',
    fontWeight: 700,
  },
  caption: {
    color: '#fff',
  },
  block: {
    display: 'block',
  },
  hidden: {
    display: 'none',
  },
});
